/**
 * @generated SignedSource<<f773109dc0920722a3ab81b0e47ebec1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UsersMap_usersMap",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sidebar",
      "kind": "LinkedField",
      "name": "sidebar",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapSidebar_sidebar"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapContextProvider_map"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapSidebar_map"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapWithSidebarLayout_map"
    }
  ],
  "type": "UsersMap",
  "abstractKey": null
};

node.hash = "4a49983a3f96cee38b05ff776826bd85";

module.exports = node;
